import React from 'react';
import PropTypes from 'prop-types';

function FormField({ children, label }) {
  return (
    <div className="create-new-user-form-row">
      <p className="label">{label}</p>
      {children}
    </div>
  );
}

FormField.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default FormField;
